import commitMutation from 'relay-commit-mutation-promise';
import { graphql } from 'react-relay';

const mutation = graphql`
    mutation sendMessageMutation($input: ContactDealerInput!) {
        contactDealer(input: $input) {
            conversation {
                id
            }
        }
    }
`;

export function sendMessageMutation({
    action,
    buyerId,
    displayName,
    environment,
    itemPk,
    messageContent,
    pageContext,
    sellerPk,
}) {
    const input = {
        action,
        buyerId,
        displayName,
        itemPk,
        messageContent,
        pageContext,
        sellerPk,
    };

    return commitMutation(environment, {
        mutation,
        variables: { input },
    });
}
